/*
 * Primitive border-radius units.
 * These reflect the border-radius units in the Figma design system.
 * Do not modify these border-radius units without design system approval.
 */

export const borderRadiusPrimitive = {
  0: 0,
  50: 2,
  100: 4,
  150: 6,
  200: 8,
  250: 10,
  300: 12,
  400: 16,
  500: 20,
  750: 30,
  full: 999,
} as const;
